import * as React from 'react';

import { TextInput } from '../../components/forms';
import Utils, { InputError } from '../../common/utils';

interface Props {
	className?: string;
	user: UserDetails;
	onUserChange: (e: any) => void;
	errors: {
		email: InputError
	};
}
interface State {
	touched: {
		email: boolean;
	};
}
class StaffDetailsForm extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			touched: {
				email: false
			}
		};
	}

	handleBlur = (field: any) => (evt: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true }
		});
	}

	render() {
		return (
			<div className={this.props.className}>
				<h2 className="form-fieldset-title">Contact Information</h2>
				<div className="form-fieldset">
					<div className="row">
						<TextInput
							labelText="First Name"
							name="firstName"
							onChange={this.props.onUserChange}
							value={this.props.user.firstName}
							className="col-md-6"
						/>
						<TextInput
							labelText="Last Name"
							name="lastName"
							onChange={this.props.onUserChange}
							value={this.props.user.lastName}
							className="col-md-6"
						/>
						<TextInput
							labelText="Email"
							name="email"
							onBlur={this.handleBlur('email')}
							onChange={this.props.onUserChange}
							value={this.props.user.email}
							className="col-md-6 mb-md-2"
							error={
								Utils.shouldMarkError(this.props.errors.email, this.state.touched.email)
									? this.props.errors.email
									: undefined
							}
						/>
						<TextInput
							labelText="Employee ID"
							name="id"
							value={this.props.user.id}
							className="col-md-6"
							disabled={true}
						/>
					</div>
				</div>
				</div>
		);
	}
}
export default StaffDetailsForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/staff/StaffDetailsForm.tsx